// Közös választéklisták a BER bérszámfejtőhöz.
export const BER_OPCIOK = {
  honapok: [
    { value: 1, label: 'Január' }, { value: 2, label: 'Február' }, { value: 3, label: 'Március' },
    { value: 4, label: 'Április' }, { value: 5, label: 'Május' }, { value: 6, label: 'Június' },
    { value: 7, label: 'Július' }, { value: 8, label: 'Augusztus' }, { value: 9, label: 'Szeptember' },
    { value: 10, label: 'Október' }, { value: 11, label: 'November' }, { value: 12, label: 'December' },
  ],
  jogviszonyTipus: [
    { value: 'munkaviszony', label: 'Munkaviszony' },
    { value: 'egyeni_vallalkozo', label: 'Egyéni vállalkozó' },
    { value: 'tarsas_vallalkozo', label: 'Társas vállalkozó (tag)' },
    { value: 'megbizas', label: 'Megbízási jogviszony' },
    { value: 'vezeto', label: 'Vezető tisztségviselő' },
    { value: 'egyeb', label: 'Egyéb' },
  ],
  // Biztosítási jelleg – az egyéni/társas vállalkozó járulékminimumát befolyásolja.
  biztositasiJelleg: [
    { value: 'foallasu', label: 'Főfoglalkozású (járulékminimum a minimálbér/garantált)' },
    { value: 'mellekallasu', label: 'Mellékfoglalkozású (heti 36 óra munkaviszony mellett)' },
    { value: 'kiegeszito', label: 'Kiegészítő tevékenységű (nyugdíj melletti)' },
  ],
  berTipus: [
    { value: 'havi', label: 'Havibér' },
    { value: 'ora', label: 'Órabér' },
    { value: 'teljesitmeny', label: 'Teljesítménybér' },
  ],
  munkarend: [
    { value: 'altalanos', label: 'Általános (heti 40 óra)' },
    { value: 'egyenlotlen', label: 'Egyenlőtlen munkaidő-beosztás' },
    //  Nincs munkaidő (heti 0 óra) – pl. a társas vállalkozó tagnál. A 2608 08M-08 lapján ilyenkor
    //  nincs munkaidő-sor (523–525.), és az 540. „arányos szolgálati idő" sor sem töltendő.
    { value: 'nincs', label: 'Munkaidő nélkül (heti 0 óra, pl. társas vállalkozó tag)' },
  ],
  neme: [
    { value: 'ferfi', label: 'Férfi' },
    { value: 'no', label: 'Nő' },
  ],
  kedvezmenyTipus: [
    { value: 'csaladi', label: 'Családi kedvezmény' },
    { value: 'fiatal25', label: '25 év alatti fiatalok kedvezménye' },
    { value: 'anya30', label: '30 év alatti anyák kedvezménye' },
    { value: 'anya2', label: 'Kétgyermekes anyák kedvezménye' },
    { value: 'anya3', label: 'Háromgyermekes anyák kedvezménye' },
    { value: 'netak', label: 'NÉTAK (négy v. több gyermekes anyák)' },
    { value: 'elsohazas', label: 'Első házasok kedvezménye' },
    { value: 'szemelyi', label: 'Személyi (súlyos fogyatékosság) kedvezmény' },
  ],
  /*  MUNKÁLTATÓI (SZOCHO) KEDVEZMÉNYEK – Szocho tv. A kedvezmény két paraméterből áll: meddig
   *  vehető figyelembe a bér (alapkorlát), és az adó hány százaléka engedhető el. A törvény
   *  lépcsőzik (pl. munkaerőpiacra lépőnél az első év a minimálbérig 100%, utána fél évig a
   *  minimálbér feléig), ezért egy lépcső = egy rögzített időszak. */
  szochoKedvezmenyTipus: [
    { value: 'szakkepzettseg_nelkul', label: 'Szakképzettséget nem igénylő / mezőgazdasági munkakör (Szocho tv. 10. §)' },
    { value: 'munkaeropiac', label: 'Munkaerőpiacra lépő (11. §)' },
    { value: 'anya3_munkaeropiac', label: 'Három v. több gyermeket nevelő, munkaerőpiacra lépő nő (12. §)' },
    { value: 'megvaltozott', label: 'Megváltozott munkaképességű személy (13. §)' },
    { value: 'kutato', label: 'Kutató, fejlesztő foglalkoztatása (15. §)' },
    { value: 'kutatas', label: 'Kutatás-fejlesztési tevékenység (16. §)' },
    { value: 'vedett_korban', label: 'Védett korban elbocsátott köztisztviselő' },
    { value: 'dualis', label: 'Szakirányú oktatás, duális képzés' },
    { value: 'egyeb', label: 'Egyéb szocho-kedvezmény' },
  ],
  szochoAlapKorlat: [
    { value: 'minimalber', label: 'a minimálbérig' },
    { value: 'fel_minimalber', label: 'a minimálbér feléig' },
    { value: 'ketszeres_minimalber', label: 'a minimálbér kétszereséig' },
    { value: 'negyszeres_minimalber', label: 'a minimálbér négyszereséig' },
    { value: 'osszeg', label: 'megadott összegig' },
    { value: 'nincs', label: 'a teljes bér után' },
  ],
  // Eltartott jogcíme a családi kedvezményhez / a bevallás M-lapjához.
  eltartottJogcim: [
    { value: 'kedvezmenyezett', label: 'Kedvezményezett eltartott' },
    { value: 'eltartott', label: 'Eltartott (sávba számít, kedvezmény nem jár utána)' },
    { value: 'felvaltva', label: 'Felváltva gondozott (fél fő)' },
    { value: 'magzat', label: 'Magzat' },
  ],
  letiltasTipus: [
    { value: 'gyermektartas', label: 'Gyermektartásdíj' },
    { value: 'egyeb_kiemelt', label: 'Egyéb kiemelt követelés' },
    { value: 'koztartozas', label: 'Köztartozás' },
    { value: 'egyeb', label: 'Egyéb' },
  ],
  // Átalányadó költséghányadok a tevékenység jellege szerint (a jogviszonynál állítandó).
  // A 45 az „általános” kategória: a számítás az adott év mértékét veszi (2025: 40%, 2026: 45%,
  // 2027-től 50% – backend/ber.js atalanyKoltseghanyad).
  koltseghanyad: [
    { value: 45, label: 'Általános tevékenység (2026: 45%, 2027-től 50%)' },
    { value: 80, label: '80% – ipari/mezőgazdasági/szolgáltató/vendéglátó tevékenység' },
    { value: 90, label: '90% – kiskereskedelem; mezőgazdasági őstermelő' },
  ],
};

export function honapNev(ho: number): string {
  return BER_OPCIOK.honapok.find((h) => h.value === ho)?.label || String(ho);
}

/** Az ügyfél adózási formája a BÉR-ügyfél jelzőiből (ezekkel számol a bérszámfejtés is);
 *  ha egyik sincs bejelölve, a NAPLO-ügyfél típusa dönt: egyéni vállalkozó → vállalkozói SZJA, egyébként TAO. */
export function adozasiForma(u: any): string {
  if (!u) return '';
  if (u.kivas) return 'KIVA';
  if (u.atalanyado) return 'Átalányadó';
  if (u.kata) return 'KATA';
  if (u.naplo_tipus === 'egyeni') return 'Vállalkozói SZJA';
  if (u.naplo_tipus === 'maganszemely') return 'Magánszemély';
  return 'TAO';
}
